// extracted by mini-css-extract-plugin
export default {"products":"products_products__aR3nt"};